function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "clear-search");

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "clear-search",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Group",
  transform: "translate(-5.000000, -5.000000)"
}, React.createElement("circle", {
  id: "Combined-Shape",
  fill: "#E3E6E7",
  transform: "translate(15.000000, 15.000000) rotate(-315.000000) translate(-15.000000, -15.000000) ",
  cx: 15,
  cy: 15,
  r: 10
}), React.createElement("path", {
  d: "M14,14 L14,10 C14,9.44771525 14.4477153,9 15,9 C15.5522847,9 16,9.44771525 16,10 L16,14 L20,14 C20.5522847,14 21,14.4477153 21,15 C21,15.5522847 20.5522847,16 20,16 L16,16 L16,20 C16,20.5522847 15.5522847,21 15,21 C14.4477153,21 14,20.5522847 14,20 L14,16 L10,16 C9.44771525,16 9,15.5522847 9,15 C9,14.4477153 9.44771525,14 10,14 L14,14 Z",
  id: "Combined-Shape",
  fill: "#9EA7A0",
  transform: "translate(15.000000, 15.000000) rotate(-315.000000) translate(-15.000000, -15.000000) "
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    version: 1.1
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/clear-search.e0b1401a.svg";
export { SvgComponent as ReactComponent };